module.exports = __webpack_public_path__ + "static/media/BlueTruck.313c72ef.svg";